export default __webpack_public_path__ + "c4045810b5f7847af742b4e22e8c8c2a.svg";